import axios from 'axios';

const getApiKey = async () => {
  const apiKeyArray = [
    'B3BZLHNXMTV4YMEK',
    '343KDGUITXE5S8N0',
    'YBZ6WZ5YEHNUGOUK',
  ];
  const randomIndex = Math.floor(Math.random() * apiKeyArray.length);
  return apiKeyArray[randomIndex];
};

const GetCompanyData = async (ticker) => {
  const apiKey = await getApiKey();
  const data = axios
    .get(
      `https://www.alphavantage.co/query?function=OVERVIEW&symbol=${ticker}&apikey=${apiKey}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
    });
  return data;
};

export default GetCompanyData;
